module.exports = __webpack_public_path__ + "img/greenstars.ff4bc925.svg";